export const getters = {
    getTasks: (state) => {
        return state.tasks || [];
    },
};
